// import { forEachNode } from '@/shared'
import { addWish, removeWish } from '@/api/wishList'

function toggleLike (target, item) {
  const dataOptions = JSON.parse(item.dataset.wishOptions)
  // const icoSelector = item.querySelector('svg')
  const idCombinationSelector = document.querySelectorAll('#idCombination')
  const quantityWantedSelector = document.querySelectorAll('#quantity_wanted')

  if (idCombinationSelector.length) {
    dataOptions.idProductAttribute = idCombinationSelector[0].value
  }

  if (quantityWantedSelector.length) {
    dataOptions.quantity = quantityWantedSelector[0].value
  }

  if (!item.classList.contains('is-active')) {
    item.querySelector('.c-btn__ico').innerHTML = appendIco()
    let icoSelector = item.querySelector('svg')
    item.classList.add('is-active')
    item.title = 'Usuń z ulubionych'
    icoSelector.classList.add('is-animating')
    addWish(dataOptions)
      .then(data => {
        if (data !== undefined) {

        }
      })
      .catch(function () {
        let icoSelector = item.querySelector('svg')
        item.classList.remove('is-active')
        icoSelector.classList.remove('is-animating')
        art.dialog({id: 'add_to_cart_dialog', fixed: true, opacity: 0.5, lock: true}).content('Brak internetu :( Spróbuj gdy się połączysz.') // eslint-disable-line
      })
  } else {
    let icoSelector = item.querySelector('svg')
    item.classList.remove('is-active')
    item.title = 'Dodaj do ulubionych'
    icoSelector.classList.remove('is-animating')
    removeWish(dataOptions)
      .then(data => {
        if (data !== undefined) {
        }
      }).catch(function () {
        let icoSelector = item.querySelector('svg')
        item.classList.add('is-active')
        icoSelector.classList.add('is-animating')
        art.dialog({id: 'add_to_cart_dialog', fixed: true, opacity: 0.5, lock: true}).content('Brak internetu :( Spróbuj gdy się połączysz.') // eslint-disable-line
      })
  }
}

function appendIco () {
  return `<svg class="o-ico o-ico--heart o-ico--s has-animate" viewBox="0 0 62 56">
    <g class="sparkle-group">
        <circle cx="2" cy="19" r="2"></circle>
        <circle cx="17" cy="7" r="2"></circle>
        <circle cx="32" cy="2" r="2"></circle>
        <circle cx="47" cy="7" r="2"></circle>
        <circle cx="60" cy="19" r="2"></circle>
    </g>

    <path class="filled" d="M31.4,54.2c-0.5,0-0.9-0.2-1.2-0.5L15.5,38.9c-3.7-3.8-3.7-9.9,0-13.6c1.8-1.8,4.3-2.8,6.8-2.8s5,1,6.8,2.8l2.3,2.3
        l2.3-2.3c1.8-1.8,4.2-2.8,6.8-2.8c2.5,0,5,1,6.8,2.8c3.7,3.7,3.7,9.8,0.1,13.6c0,0-14.7,14.8-14.7,14.8
        C32.3,54,31.9,54.2,31.4,54.2z"/>
    <path d="M40.5,24.2c2.1,0,4.1,0.8,5.5,2.3c3.1,3.1,3.1,8.1,0,11.2l0,0L31.4,52.4L16.8,37.7c-3.1-3.1-3.1-8.1,0-11.2
        c1.5-1.5,3.5-2.3,5.5-2.3c2.1,0,4.1,0.8,5.5,2.3l2.3,2.3c0.3,0.3,0.8,0.5,1.2,0.5c0.4,0,0.9-0.2,1.2-0.5l2.3-2.3
        C36.4,25,38.4,24.2,40.5,24.2 M40.5,20.7c-3,0-5.9,1.2-8,3.4l-1,1.1l-1-1.1c-2.1-2.1-5-3.3-8-3.3c-3,0-5.9,1.2-8,3.4
        c-4.4,4.4-4.4,11.7,0,16.1l14.6,14.7c0.7,0.7,1.6,1,2.5,1s1.8-0.4,2.5-1l14.6-14.7c0,0,0.1-0.1,0.1-0.1c4.3-4.4,4.3-11.6-0.1-16
        C46.4,21.9,43.5,20.7,40.5,20.7L40.5,20.7z"/>
  </svg>`
}

export function renderWishlist () {
  // const btn = document.querySelectorAll('.js-wishlist-trigger')

  // forEachNode(btn, (item) => {
  //   item.addEventListener('click', (e) => {
  //     e.preventDefault()

  //     toggleLike(e.target, item)
  //   }, false)
  // })

  // eslint-disable-next-line no-undef
  $(document).on('click', '.js-wishlist-trigger', function (event) {
    toggleLike(event.target, this)
  })
}



// WEBPACK FOOTER //
// ./src/modules/wishlist.js